var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.layout !== 'mobile')?_c('h3',[_vm._v("Orders")]):_vm._e(),_c('canvas',{ref:"root"})])
}
var staticRenderFns = []

export { render, staticRenderFns }